module.exports = __webpack_public_path__ + "static/media/bgmusic.a11aacc3.mp3";